import { combineReducers } from '@reduxjs/toolkit';

import { rentAll } from './all/rentAll';
import { rentAllList } from './all/rentAllList';

import { rent } from './core/rent';
import { rentList } from './core/rentList';

export default combineReducers({
    rentAll,
    rentAllList,
    rent,
    rentList,
});
